module.exports = __webpack_public_path__ + "img/device_1017_2.53a7e03d.svg";